<template>
    <div class="main"
         :style="{'background': detail.background_color || '#FFF'}">
        <my-nav-bar title=""
                    :bordered="false"
                    :background="detail.background_color"
                    textColor="#FFF"
                    v-if="detail">
            <template slot="right">
                <!--                <img src="@/assets/img/share.png" alt="" class="share">-->
                <span class="iconfont icon-fenxiang"></span>
            </template>
        </my-nav-bar>
        <div class="info">
            <div class="cover">
                <img :src="detail.img"
                     alt="">
            </div>
            <div class="right"
                 @click="changeOpen">
                <div class="top">
                    <span class="title">{{ detail.name }}</span>
                </div>
                <div class="author"
                     v-if="detail.anchor">
                    <div class="auth-info">
                        <div class="avatar">
                            <img :src="detail.anchor[0].image"
                                 alt="">
                        </div>
                        <span class="name">
                            {{this.detail.anchor.map(item=>item.nickname).join(" | ")}}
                        </span>
                    </div>
                </div>
                <div class="describe"
                     v-if="!isOpen">
                    <div class="content">{{ detail.description }}</div>
                </div>
            </div>
        </div>
        <div v-if="isOpen"
             class="detail">
            <span class="sub-title">简介</span>
            <p>{{ detail.description }}</p>
            <span class="sub-title">主播</span>
            <div class="anchor"
                 v-for="(item, index) in detail.anchor"
                 :key="index">
                <div class="left">
                    <img :src="item.image"
                         alt="">
                    <span>{{ item.nickname }}</span>
                </div>
                <div class="follow"
                     v-if="true"
                     @click="openDownModal">+关注</div>
                <div class="follow ed"
                     v-else>已关注</div>
            </div>
        </div>
        <div class="close-detail"
             @click="changeOpen"
             v-show="isOpen">
            <span>点击收起</span>
            <span class="iconfont icon-jiantoushang"></span>
        </div>
        <div class="process-bar"
             v-show="(!isOpen) && isCurPagePlay">
            <div class="process">
                <div class="line"
                     :style="{'width': rateNum + 'px'}"></div>
                <div class="rate"
                     :style="{'left': rateNum + 'px'}">{{passTime | formatTime}}/{{audioInfo.totalTime | formatTime}}</div>
            </div>
            <div class="operate">
                <div class="item">
                    <span class="iconfont icon-speed"
                          @click="openDownModal('请在APP内使用')"></span>
                </div>
                <span class="iconfont icon-prev"
                      @click="prevAudio"></span>
                <div class="play"
                     @click="playVideo()">
                    <span class="iconfont icon-play"
                          v-if="isCurPagePlay && status != PLAY"></span>
                    <span class="iconfont icon-pause"
                          v-else></span>
                </div>
                <span class="iconfont icon-next"
                      @click="nextAudio('button')"></span>
                <div class="item"
                     @click="openDownModal('请在APP内使用')">
                    <span class="iconfont icon-bell"></span>
                </div>
            </div>
        </div>
        <div class="list"
             v-show="!isOpen">
            <div class="tabs">
                <div :class="{'item': true, 'active': this.active == 0}"
                     @click="changeTab(0)">节目</div>
                <div :class="{'item': true, 'comment': true, 'active': this.active == 1}"
                     @click="changeTab(1)">评论<span class="num">{{ detail.comments }}</span></div>
            </div>
            <div id="mescroll"
                 class="mescroll"
                 :style="{'height': height + 'px'}">
                <template v-if="active == 0">
                    <div class="status-bar"
                         v-if="false">
                        <div class="play-btn"
                             @click="playVideo()">
                            <template v-if="isCurPagePlay">
                                <template v-if="status == PAUSE">
                                    <span class="iconfont icon-play"></span>
                                    <span>继续播放</span>
                                </template>
                                <template v-else>
                                    <span class="iconfont icon-pause"></span>
                                    <span>暂停播放</span>
                                </template>
                            </template>
                            <template v-else>
                                <span class="iconfont icon-play"></span>
                                <span>全部播放</span>
                            </template>
                        </div>
                        <div class="setting"
                             v-if="chapterList.length>0">
                            <span class="iconfont icon-download"
                                  style="margin-right: 16px"
                                  @click="openDownModal('请在APP内使用')"></span>
                            <span class="iconfont icon-sort"
                                  @click="openDownModal('请在APP内使用')"></span>
                            <div class="chapter"
                                 @click="showChapter = true">
                                <span class="num">{{chapterList[curChapter].start || 1}}-{{ chapterList[curChapter].end || 1 }}</span>
                                <span class="iconfont icon-jiantouxia"
                                      v-if="!showChapter"></span>
                                <span class="iconfont icon-jiantoushang"
                                      v-else></span>
                            </div>
                        </div>
                    </div>
                    <!--                    <div class="play-info" v-if="pageAudioInfo.name">-->
                    <!--                        <div class="play-circle">-->
                    <!--                            <span class="iconfont icon-play" v-if="status != PLAY"></span>-->
                    <!--                            <img src="@/assets/img/ic_live.gif" alt="" v-else>-->
                    <!--                        </div>-->
                    <!--                        <div>{{status == PLAY ? "正在播放" : "继续播放"}}：{{ pageAudioInfo.name }}</div>-->
                    <!--                    </div>-->
                </template>
                <div>
                    <div class="videos"
                         v-if="active == 0">
                        <div class="item"
                             v-for="(item, index) in list"
                             :key="index"
                             @click="playVideo(item, true)">
                            <div>
                                <span :class="{'title': true, 'playing': item.id == audioInfo.id}">{{item.title}}</span>
                                <div class="video-info">
                                    <!--                                <div class="tag" v-if="item.is_audition == 1">试听</div>-->
                                    <!--                                <div class="tag tag-vip" v-else>会员</div>-->
                                    <div class="views">
                                        <span class="iconfont icon-headset"></span>
                                        {{item.views}}
                                    </div>
                                    <div class="comments">
                                        <span class="iconfont icon-message"></span>
                                        {{item.comments}}
                                    </div>
                                    <div class="time">
                                        <span class="iconfont icon-clock"></span>
                                        {{item.playtime}}
                                    </div>
                                </div>
                            </div>
                            <div class="play-circle">
                                <span class="iconfont icon-play"
                                      v-if="item.id != audioInfo.id"></span>
                                <!--                            <span class="iconfont icon-pause"></span>-->
                                <img src="@/assets/img/ic_live.gif"
                                     alt=""
                                     v-else>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <CommentList :dataSource="comment" />
                    </div>
                </div>
            </div>
            <van-popup v-model="showChapter"
                       position="bottom"
                       round>
                <div class="popup-body">
                    <div class="sub-title">选集</div>
                    <div class="chapter-list">
                        <div @click="changeChapter(index)"
                             :class="{'item': true, 'active': index == curChapter}"
                             v-for="(item, index) in chapterList"
                             :key="index">{{item.start}}-{{item.end}}集</div>
                    </div>
                    <div class="cancel"
                         @click="showChapter = false">取消</div>
                </div>
            </van-popup>
        </div>
        <g-player :audioType="VIRTUAL_VIDEO"
                  ref="player" />
    </div>
</template>

<script>
import { NavBar, Toast } from "vant";
import CommentList from "@/components/CommentList";
import Comment from "../../Patting/Comment";
import { VirtualDetailApi, CommentListApi } from "@/request/api";
import { VIRTUAL_VIDEO, PAUSE, PLAY } from "@/global/constant";
import { AudioInfo } from "@/global/audio";
import { mapState } from "vuex";
import { Message } from "element-ui";

export default {
    data() {
        return {
            VIRTUAL_VIDEO,
            PLAY,
            PAUSE,
            active: 0,
            list: [],
            step: 20,
            comment: [],
            mescroll: null,
            height: 0,
            isOpen: false,
            showChapter: false,
            chapterList: [],
            curChapter: 0,
            id: 0,
            detail: {},
            filter: {
                page: 1,
                pcount: 10,
            },
            nameStr: "",
            finished: false,
            pageAudioInfo: {},
            // 音频是否为当前页
            isCurPagePlay: false,
            timer: null,
            rateNum: 0,
            // passTime: 0,
            totalTime: 100,
            process: 0,
            rate: 0,
        };
    },

    components: { Comment, NavBar, CommentList },
    watch: {
        curChapter() {
            this.setAudioList();
        },
        passTime(val) {
            let width = this.process - this.rate;
            this.rateNum = width * (val / this.audioInfo.totalTime);
        },
    },
    computed: {
        ...mapState({
            audioInfo: (state) => state.audio.audioInfo,
            status: (state) => state.audio.status,
            passTime: (state) => state.audio.passTime,
        }),
    },
    filters: {
        formatTime(time) {
            let second = "";
            let minutes = "";
            second = time % 60;
            minutes = parseInt(time / 60);
            return `${minutes > 9 ? minutes : "0" + minutes}:${
                second > 9 ? second : "0" + second
            }`;
        },
    },
    created() {
        // 需要等于这个才可以去赋值
        if (this.audioInfo.type == VIRTUAL_VIDEO) {
            this.pageAudioInfo = this.audioInfo;
        }
    },
    mounted() {
        this.initScroll();
        this.id = this.$route.query.id || 172;
        this.getData();
    },
    methods: {
        setRate() {
            this.$nextTick(() => {
                this.rate = document
                    .getElementsByClassName("rate")[0]
                    .getBoundingClientRect().width;
                this.process = document
                    .getElementsByClassName("process")[0]
                    .getBoundingClientRect().width;
            });
            return;
            let width = 0;
            const setProcess = () => {
                if (this.process && width == 0) {
                    width = this.process - this.rate;
                }
                if (this.passTime < this.totalTime) {
                    this.passTime++;
                    this.rateNum = width * (this.passTime / this.totalTime);
                } else {
                    clearTimeout(this.timer);
                }
            };
            setProcess();
            this.timer = setInterval(() => {
                setProcess();
            }, 1000);
        },
        // 重置进度条
        resetRate() {
            this.passTime = 0;
            this.rateNum = 0;
            clearInterval(this.timer);
        },
        changeTab(index) {
            this.active = index;
            if (this.active != 0) {
                this.finished = false;
                this.filter.page = 1;
                this.mescroll.showUpScroll();
                this.getComment();
            } else {
                this.mescroll.hideUpScroll();
            }
        },
        getData() {
            VirtualDetailApi({ id: this.id }).then((res) => {
                this.detail = res.data;
                this.$bus.$emit("linkDataUpdate", {
                    redirectPath: 22,
                    cid: this.id,
                });
                this.$bus.$emit("linkDataUpdateModel", {
                    redirectPath: 22,
                    cid: this.id,
                    });
                // 分享配置
                this.globalInitWxShare(
                    this.detail.name,
                    this.detail.description,
                    this.detail.img
                );
                this.initChapterList(this.detail.program_sum);
                this.getComment();
                this.playVideo(this.detail.program[0]);
                if (this.pageAudioInfo.id) this.setIsCurPagePlay();
            });
        },
        setIsCurPagePlay() {
            // isCurPagePlay
            this.detail.program.forEach((item) => {
                if (item.id == this.pageAudioInfo.id) this.isCurPagePlay = true;
            });
        },
        getComment() {
            CommentListApi({
                ...this.filter,
                type: 0,
                cid: this.detail.contentid,
            }).then((res) => {
                if (this.filter.page == 1) {
                    this.comment = res.data;
                } else {
                    this.comment = [...this.comment, ...res.data];
                }
                this.finished = res.data.length < this.filter.pcount;
                if (this.finished) this.mescroll.showNoMore();
            });
        },
        setTotalTime(str) {
            let minutes = parseInt(str.split(":")[0]);
            let second = parseInt(str.split(":")[1]);
            this.totalTime = minutes * 60 + second;
        },
        playVideo(data) {
            this.setRate();
            if (data) {
                // if(!this.checkIsVip(data)){
                //     return
                // }
                if (data.id == this.pageAudioInfo.id) return;
                // 停止正在播放的音频
                this.player.stop();
                // this.setTotalTime(data.playtime);
                // this.resetRate()
                // this.pageAudioInfo = new AudioInfo(data.id, data.title, data.url, this.detail.img, VIRTUAL_VIDEO)
                this.pageAudioInfo = {
                    id: data.id,
                    name: data.title,
                    url: data.url,
                    poster: this.detail.img,
                    type: VIRTUAL_VIDEO,
                    totalTime: this.transTime(data.playtime),
                };
                this.$nextTick(() => {
                    this.player.play(this.pageAudioInfo, this.nextAudio);
                });
            } else {
                // 没有传入data则为点击顶部按钮播放
                if (Object.keys(this.pageAudioInfo).length > 0) {
                    if (this.status == PLAY) {
                        // 已经有播放中的信息时暂停播放
                        this.player.pause();
                        clearInterval(this.timer);
                    } else {
                        this.player.resume();
                        this.setRate();
                    }
                } else {
                    let tmp = this.list[0];
                    if (!this.checkIsVip(tmp)) {
                        return;
                    }
                    // this.pageAudioInfo = new AudioInfo(tmp.id, tmp.title, tmp.url, this.detail.img, VIRTUAL_VIDEO)
                    this.pageAudioInfo = {
                        id: tmp.id,
                        name: tmp.title,
                        url: tmp.url,
                        poster: this.detail.img,
                        type: VIRTUAL_VIDEO,
                        totalTime: this.transTime(tmp.playtime),
                    };
                    this.player.play(this.pageAudioInfo, this.nextAudio);
                }
            }
            this.isCurPagePlay = true;
        },
        transTime(str) {
            let minutes = parseInt(str.split(":")[0]);
            let second = parseInt(str.split(":")[1]);
            return minutes * 60 + second;
        },
        checkIsVip(data) {
            if (data.is_audition == 0) {
                this.openDownModal("打开APP购买专辑");
                return false;
            } else {
                return true;
            }
        },
        // 初始化章节分页
        initChapterList(totalNum) {
            let cur = 0;
            let arr = [];
            while (totalNum > cur) {
                let obj = { start: 0, end: 0 };
                obj.start = cur + 1;
                if (totalNum < cur + this.step) {
                    cur = totalNum;
                } else {
                    cur += this.step;
                }
                obj.end = cur;
                arr.push(obj);
            }
            this.chapterList = arr;
            this.setAudioList();
        },
        // 设置音频列表
        setAudioList() {
            let data = this.chapterList[this.curChapter];
            this.list = this.detail.program.slice(data.start - 1, data.end);
        },
        // 下一部
        nextAudio(type) {
            if (this.isCurPagePlay) {
                let curIndex = -1;
                this.list.forEach((item, index) => {
                    if (item.id == this.audioInfo.id) {
                        curIndex = index;
                    }
                });
                if (curIndex == -1) return;
                if (curIndex + 1 >= this.list.length) {
                    if (type == "button") {
                        return Toast("没有下一首了");
                    } else {
                        this.rateNum = 0;
                        this.player.stop();
                    }
                } else {
                    this.rateNum = 0;
                    this.playVideo(this.list[curIndex + 1]);
                }
            } else {
                this.playVideo();
            }
        },
        // 上一部
        prevAudio() {
            if (this.isCurPagePlay) {
                let curIndex = -1;
                this.list.forEach((item, index) => {
                    if (item.id == this.audioInfo.id) {
                        curIndex = index;
                    }
                });
                console.log(curIndex);
                if (curIndex <= 0) {
                    return Toast("没有上一首了");
                } else {
                    this.rateNum = 0;
                    this.playVideo(this.list[curIndex - 1]);
                }
            } else {
                this.playVideo();
            }
        },
        initScroll() {
            this.height = document.body.clientHeight - 300;
            this.mescroll = new MeScroll("mescroll", {
                up: {
                    callback: this.reachBottom,
                },
            });
        },
        changeOpen() {
            this.isOpen = !this.isOpen;
        },
        changeChapter(index) {
            this.curChapter = index;
        },
        reachBottom() {
            if (this.finished || this.active == 0) return;
            this.filter.page++;
            this.getComment();
        },
    },
};
</script>

<style lang="less" scoped>
@baseColor: #a26e71;
@baseTextColor: #ff4c67;
.main {
    width: 100%;
    min-height: 100vh;
    background-color: @baseColor;
}
.share {
    width: 24px;
    height: 24px;
}
.info {
    padding: 20px 16px;
    display: flex;
    align-items: center;
    height: 90px;
    .cover {
        width: 90px;
        height: 90px;
        border-radius: 6px;
        position: relative;
        overflow: hidden;
        margin-right: 12px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .right {
        color: #fff;
        height: 90px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .top {
            display: flex;
            flex-direction: column;
            .title {
                font-size: 16px;
            }
            .status {
                margin-top: 4px;
                font-size: 12px;
                opacity: 0.5;
            }
        }
        .author {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            .auth-info {
                margin: 5px 0;
                display: flex;
                align-items: center;
                .avatar {
                    min-width: 20px;
                    min-height: 20px;
                    max-width: 20px;
                    max-height: 20px;
                    border: 1px solid #fff;
                    box-sizing: border-box;
                    border-radius: 50%;
                    overflow: hidden;
                    margin-right: 4px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .follow {
                padding: 6px 12px;
                border-radius: 50px;
                background: linear-gradient(to right, #ff7b9a, #ff1544);
                font-size: 14px;
                white-space: nowrap;
            }
        }
    }
}
.describe {
    padding: 12px;
    background-color: rgba(0, 0, 0, 0.1);
    color: #fff;
    font-size: 12px;
    border-radius: 4px;
    .content:extend(.hide-2) {
        color: #ffffff;
    }
}
.list {
    width: 100%;
    height: auto;
    background-color: #fff;
    position: fixed;
    left: 0;
    bottom: 0;
    border-radius: 16px 16px 0 0;
}
.tabs {
    margin: 10px 12px;
    border-bottom: 1px solid #eeeeee;
    padding-bottom: 4px;
    width: 100%;
    overflow-x: scroll;
    display: flex;
    align-items: center;
    .item {
        margin-right: 16px;
        position: relative;
        width: 40px;
        text-align: center;
        height: 35px;
        line-height: 35px;
        color: #646464;
        position: relative;
        .num {
            position: absolute;
            font-size: 10px;
            top: -7px;
            right: -10px;
        }
        &::before {
            content: "";
            width: 24px;
            height: 4px;
            background-color: #fff;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 50px;
        }
        &.active {
            font-size: 20px;
            color: @baseTextColor;
            &::before {
                background-color: @baseTextColor;
            }
            .num {
                right: -23px;
            }
        }
    }
}
.status-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    margin-bottom: 10px;
    color: #646464;
    .play-btn {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #222;
        padding: 6px 12px;
        background-color: #f8f8f8;
        max-width: 96px;
    }
    .setting {
        display: flex;
        align-items: center;
        .chapter {
            display: flex;
            align-items: center;
            .iconfont {
                font-size: 12px;
            }
            .num {
                white-space: nowrap;
                font-size: 13px;
                margin-right: 2px;
            }
        }
    }
    .icon-sort {
        margin-right: 16px;
    }
}
.play-info {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 16px;
    background-color: rgba(#ff4c67, 0.1);
    color: @baseTextColor;
    font-size: 14px;
    display: flex;
    align-items: center;
    .play-circle {
        width: 24px;
        height: 24px;
        background-color: @baseTextColor;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        margin-right: 8px;
        img {
            width: 13px;
        }
    }
}
.play-circle {
    width: 24px;
    height: 24px;
    background-color: @baseTextColor;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-right: 8px;
    img {
        width: 13px;
    }
}
.videos {
    .item {
        width: 100%;
        box-sizing: border-box;
        padding: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
            font-size: 14px;
            line-height: 20px;
            color: #a7a7a7;
        }
        .playing {
            color: @base-color;
        }
        .video-info {
            display: flex;
            .tag {
                padding: 2px 3px;
                border-radius: 2px;
                border: 1px solid @baseTextColor;
                color: @baseTextColor;
                font-size: 9px;
                margin-right: 10px;
                transform: scale(0.9);
                &.tag-vip {
                    border-color: #d0a85c;
                    color: #d0a85c;
                }
            }
        }
        .views,
        .comments,
        .time {
            color: #a7a7a7;
            font-size: 11px;
            display: flex;
            align-items: center;
            width: 50px;
            .iconfont {
            }
        }
    }
}
.close-detail:extend(.flex-cen) {
    position: fixed;
    left: 50%;
    bottom: 50px;
    transform: translateX(-50%);
    font-size: 14px;
    color: #fff;
    padding: 8px 16px;
    border-radius: 50px;
    background-color: rgba(#222222, 0.5);
    .iconfont {
        font-size: 12px;
        margin-left: 2px;
    }
}
.detail {
    padding: 24px 16px;
    color: #fff;
    font-size: 13px;
    p {
        margin-bottom: 20px;
        line-height: 22px;
    }
    .sub-title {
        margin-bottom: 16px;
        display: block;
        font-size: 18px;
    }
    .anchor:extend(.flex-btw) {
        .left:extend(.flex-cen) {
            margin-bottom: 16px;
            img {
                width: 36px;
                height: 36px;
                border-radius: 50%;
                margin-right: 12px;
            }
        }
        .follow:extend(.flex-cen) {
            width: 68px;
            height: 32px;
            color: #fff;
            border-radius: 50px;
            border: 1px solid #fff;
            &.ed {
                color: rgba(#fff, 0.5);
                border-color: rgba(#fff, 0.5);
            }
        }
    }
}
.popup-body {
    padding: 16px;
    box-sizing: border-box;
    position: relative;
    .sub-title {
        font-size: 16px;
        line-height: 22px;
    }
    .chapter-list {
        height: 250px;
        overflow-y: scroll;
        justify-content: space-between;
        display: grid;
        grid-template-columns: 106px 106px 106px;
        grid-row-gap: 12px;
        margin-top: 12px;
        .item:extend(.flex-cen) {
            width: 100%;
            border: 1px solid #cccccc;
            //height: 50px;
            max-height: 30px;
            padding: 6px 0;
            font-size: 12px;
            border-radius: 50px;
            transition: all linear 0.2s;
            &.active {
                color: #fff;
                background-color: #ff4c67;
                border: none;
            }
        }
    }
    .cancel {
        height: 44px;
        line-height: 44px;
        border: 1px solid #eeeeee;
        border-radius: 100px;
        text-align: center;
        margin-top: 20px;
    }
}
.process-bar {
    margin-top: 40px;
    box-sizing: border-box;
    padding: 0 10px;
    .operate:extend(.flex-aro) {
        .iconfont {
            color: #fff;
            font-size: 20px;
        }
        .play:extend(.flex-cen) {
            width: 35px;
            height: 35px;
            border-radius: 50%;
            background-color: @base-color;
            .iconfont {
                margin-left: 2px;
            }
        }
    }
    .process {
        width: 100%;
        height: 1px;
        background-color: rgba(#fff, 0.2);
        position: relative;
        margin-bottom: 20px;
        &:before,
        &:after {
            content: "";
            width: 3px;
            height: 3px;
            position: absolute;
            border-radius: 50%;
            background-color: #fff;
            top: -1px;
        }
        &:before {
            left: 0;
        }
        &:after {
            right: 0;
        }
        .line {
            height: 100%;
            background-color: #fff;
        }
        .rate:extend(.flex-cen) {
            background-color: #fff;
            border-radius: 100px;
            position: absolute;
            height: 21px;
            font-size: 10px;
            padding: 0 6px;
            top: -10px;
            //transition: all linear 1s;
        }
    }
}
</style>
